import * as Sentry from '@sentry/react';
import { ReactNode, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';

import { SentryManager } from './services/sentry';
import { environment } from './utils/environment';

const sentryManager = new SentryManager();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WrapErrorBoundary>
      <App />
    </WrapErrorBoundary>
  </StrictMode>
);

function WrapErrorBoundary({ children }: { children: ReactNode }) {
  if (environment.isLocal || !sentryManager.isEnabled) {
    return children;
  }

  return <Sentry.ErrorBoundary>{children}</Sentry.ErrorBoundary>;
}
